module.exports = __webpack_public_path__ + "static/media/fumatul.9db7fd49.jpeg";